import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AuthenticationRoute extends Route {
  @service session;
  @service router;
  @service currentUser;
  @service store;
  @service('data-socket') socketService;

  queryParams = {
    code: {
      refreshModel: false,
    },
  };

  async beforeModel() {
    await this.session.invalidate();
  }

  model(params) {
    const { code } = params;
    const rawState = this.router.currentRoute?.parent?.queryParams?.state;
    let clientId = null;
    try {
      const state = rawState ? JSON.parse(atob(rawState)) : null;
      clientId = state?.clientId ?? null;
    } catch {
      console.warn('Failed to parse OAuth state parameter:', rawState);
    }
    this.session
      .authenticate('authenticator:oauth2-implicit-grant', {
        code,
        clientId,
      })
      .catch((error) => {
        console.log(error);
        this.router.transitionTo('login');
      });
  }
}
